<template>
  <div class="reverseInvoiceList">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="invoiceApplication">
      <div slot="toolbar">
        <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :before-upload="beforeAvatarUpload"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin: 0 5px">
          <el-button :loading="importLoading" icon="el-icon-upload2" type="success">附件导入</el-button>
        </el-upload>
        <el-button icon="el-icon-download" type="primary" plain @click="downloadExcel()">导入模板下载</el-button>
      </div>
      <template slot="adSearch">
        <vm-search label="状态">
          <el-select v-model="filter.status" clearable>
            <el-option label="全部" :value="-1"/>
            <el-option label="草稿" :value="0"/>
            <el-option label="已提交" :value="10"/>
            <el-option label="已驳回" :value="20"/>
            <el-option label="部分开票" :value="25"/>
            <el-option label="已开票" :value="30"/>
            <el-option label="已冲销" :value="40"/>
          </el-select>
        </vm-search>
        <vm-search label="申请日期">
          <el-date-picker
              v-model="createTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="createTimeChange"/>
        </vm-search>
        <vm-search label="提交日期">
          <el-date-picker
              v-model="submitTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="submitTimeChange"/>
        </vm-search>
        <vm-search label="通过日期">
          <el-date-picker
              v-model="passTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="passTimeChange"/>
        </vm-search>
        <vm-search label="申请编号">
          <el-input v-model="filter.invoiceApplicationNo" clearable/>
        </vm-search>
        <vm-search label="发货单号">
          <el-input v-model="filter.invoiceNo" clearable/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model="filter.factoryNo" clearable/>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="创建人">
          <el-input v-model="filter.creatorName" clearable/>
        </vm-search>
      </template>
      <el-table-column align="center" prop="invoiceApplicationNo" label="申请编号" width="150">
        <template slot-scope="scope">
          <span
              style="color: #2d8cf0; cursor: pointer"
              @click="goto(scope.row)">{{scope.row.invoiceApplicationNo}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="invoiceStatus" label="发票类型" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.invoiceStatus === '1' ? 'primary' : 'danger'">
            <span v-if="scope.row.invoiceStatus === '1'">蓝票</span>
            <span v-if="scope.row.invoiceStatus === '2'">红票</span>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="cancelSign" label="冲销标识" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.cancelSign === true">X</span>
          <span v-else/>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="85">
        <template slot-scope="scope">
          <span v-if="scope.row.status ===0">草稿</span>
          <span v-if="scope.row.status ===10">已提交</span>
          <span v-if="scope.row.status ===20">已驳回</span>
          <span v-if="scope.row.status ===25">部分开票</span>
          <span v-if="scope.row.status ===30">已开票</span>
          <span v-if="scope.row.status ===40">已冲销</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="customerName"
          label="客户名称"
          width="200"
          show-overflow-tooltip/>
      <el-table-column align="center" prop="invoiceTotalAmount" label="价税合计" width="100"/>
      <el-table-column align="center" prop="createTime" label="申请日期" width="150"/>
      <el-table-column align="center" prop="submitTime" label="提交日期" width="150"/>
      <el-table-column align="center" prop="passTime" label="开票日期" width="150"/>
      <el-table-column align="center" prop="creatorName" label="创建人" width="150"/>
      <el-table-column align="center" prop="zjsfphm" label="金税票号" width="200"/>
      <el-table-column prop="jSStatus" label="开票状态" align="center" width="80">
        <template v-slot="scope">
          <el-tag v-if="scope.row.jsstatus !== null" :type="scope.row.jsstatus === 'S' ? 'success' : 'danger'">
            <el-tooltip
                v-if="scope.row.jsstatus === 'R'"
                class="item"
                effect="dark"
                placement="top-start"
                :content="scope.row.jsRejectReason">
              <i class="el-icon-warning"/>
            </el-tooltip>
            {{scope.row.jsstatus}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
              v-if="scope.row.status === 0 || scope.row.status === 10 || scope.row.status === 20"
              type="primary"
              @click="goto(scope.row, true)">
            编辑
          </el-button>
          <el-button
              v-if="scope.row.status === 0 || scope.row.status === 20"
              type="primary"
              @click="updateStatus(scope.row,10)">
            提交
          </el-button>
          <el-button
              v-if="passAuth && (scope.row.status === 10 || scope.row.status === 25)"
              type="primary"
              :loading="createLoading"
              @click="createSapInvoice(scope.row)">
            开票
          </el-button>
          <el-button v-if="passAuth && scope.row.status === 10" type="danger" @click="updateStatus(scope.row,20)">
            驳回
          </el-button>
          <el-button v-if="passAuth && (scope.row.status === 30 || scope.row.status === 25) && scope.row.jsstatus !== 'S' && scope.row.cancelSign === false" :loading="rejectLoading" type="danger" @click="reject(scope.row)">
            冲销
          </el-button>
          <el-button v-if="scope.row.zjsfphm !== '' && passAuth && scope.row.invoiceStatus === '1' && scope.row.cancelSign === false && scope.row.status === 30" type="danger" @click="cancelSapInvoice(scope.row)">
            整单红冲
          </el-button>
          <el-button v-if="scope.row.status ===0 || scope.row.status === 20" type="danger" @click="deleteOne(scope.row)">
            删除
          </el-button>
          <el-button v-if="downloadAuth && scope.row.status === 30 && scope.row.zjsfphm" type="primary" @click="handleDownload(scope.row)">
            下载发票
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <invoice-download-type-select ref="invoiceDownload"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import loginUtil from "@/util/loginUtil";
  import InvoiceDownloadTypeSelect from "@/views/invoicingManagement/invoiceApplication/InvoiceDownloadTypeSelect.vue";

  export default {
    name: "InvoiceApplicationList",
    components: {InvoiceDownloadTypeSelect, VmTable, VmSearch},
    data() {
      return {
        selection: [],
        passAuth: this.$auth(435),
        downloadAuth: this.$auth(712),
        createTime: "",
        submitTime: "",
        passTime: "",
        createLoading:false,
        files: [],
        importLoading:false,
        rejectLoading:false,
        uploadUrl: window.config.basicServerUrl + "invoiceApplication/importFile",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        uploadLoading:false,
        filter: {
          status: -1,
          factoryNo: "",
          invoiceNo: "",
          invoiceApplicationNo: "",
          customerName: "",
          createTimeBegin: "",
          createTimeEnd: "",
          submitTimeBegin: "",
          submitTimeEnd: "",
          passTimeBegin: "",
          passTimeEnd: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      goto(row, isEdit) {
        let url = isEdit ? "/InvoiceApplicationEdit" : "/InvoiceApplicationPreview";
        this.$router.push({
          path: url,
          query: {
            billId: row.pkid,
            $tabName: row.invoiceApplicationNo,
          },
        });
      },

      deleteOne(row) {
        this.$http.delete("basic", "invoiceApplication", row.pkid)
          .then(() => {
            this.$message.success("删除成功");
            this.getList(1);
          }).catch(() => {
            this.$message.error("删除失败");
          });
      },

      updateStatus(row, status) {
        this.$http.get("basic", `invoiceApplication/updateStatus/${row.pkid}/${status}`)
          .then(() => {
            this.$message.success("更新成功");
            this.getList();
          }).catch(() => {
            this.$message.error("更新失败");
          });
      },

      createTimeChange(date) {
        if (date !== null) {
          this.filter.createTimeBegin = date[0];
          this.filter.createTimeEnd = date[1];
        } else {
          this.filter.createTimeBegin = "";
          this.filter.createTimeEnd = "";
        }
      },

      submitTimeChange(date) {
        if (date !== null) {
          this.filter.submitTimeBegin = date[0];
          this.filter.submitTimeEnd = date[1];
        } else {
          this.filter.submitTimeBegin = "";
          this.filter.submitTimeEnd = "";
        }
      },

      passTimeChange(date) {
        if (date !== null) {
          this.filter.passTimeBegin = date[0];
          this.filter.passTimeEnd = date[1];
        } else {
          this.filter.passTimeBegin = "";
          this.filter.passTimeEnd = "";
        }
      },

      createSapInvoice(row) {
        if(this.createLoading) return;
        this.createLoading=true;
        this.$http.get("basic",`invoiceApplication/createSapInvoice/${row.pkid}`)
          .then((resp)=>{
            if (resp.success) {
              this.$message.success(resp.message);
            }else{
              this.$message.error(resp.message);
            }
          }).finally(()=>{
            this.createLoading=false;
            this.getList();
          });
      },

      cancelSapInvoice(row) {
        console.log(row);
        this.$router.push({
          path: "/InvoiceApplicationPreview",
          query: {
            billId: 0,
            $tabName: "开票申请",
            cancelId: row.pkid,
            selection:[],
          },
        });
      },

      //导入
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },


      //下载说明
      downloadExcel() {
        window.open("/publicFile/开票导入模板.xlsx");
      },

      reject(row) {
        this.rejectLoading=true;
        this.$http.get("basic",`invoiceApplication/cancelInvoice/${row.pkid}`)
          .then((resp)=>{
            if (resp.success) {
              this.$message.success(resp.data);
            }else{
              this.$message.error(resp.message);
            }
          }).finally(()=>{
            this.rejectLoading=false;
            this.getList();
          });
      },

      handleDownload(row) {
        this.$refs.invoiceDownload.open(row.invoiceApplicationNo);
      },

    },
  };
</script>
<style lang="scss">
</style>
